import React from 'react';
import { MdBlock } from 'react-icons/md';
import './SuspendedAccountNotice.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.('frontElakayHardcodedText', __elakayInfoSource.languageAPI)?.['suspendedaccountnotice']?.[key] || fallback;

const formatDate = (value) => {
  if (!value) return __elakayText('t006', 'Unlimited');
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString();
};

// Shown on Signin.js in place of the login form when the backend refuses a
// login with errorCode "ACCOUNT_SUSPENDED" (a "User"-level suspension --
// see elakay_models/user.js's findByCredentials). Only a full-account
// suspension blocks login; per-role suspensions never reach this screen.
const SuspendedAccountNotice = ({ suspension, infoSource, onBack }) => {
  __setElakayInfoSource(infoSource);
  const supervisorName = suspension?.supervisor?.firstname
    ? `${suspension.supervisor.firstname} ${suspension.supervisor.lastname || ''}`.trim()
    : suspension?.supervisor?.email;

  return (
    <div className="suspended-account-notice">
      <div className="suspended-account-icon"><MdBlock /></div>
      <h2>{__elakayText('t001', 'Your account is suspended')}</h2>

      <div className="suspended-account-detail">
        <span className="suspended-account-label">{__elakayText('t002', 'Reason')}</span>
        <span>{suspension?.reason}</span>
      </div>
      {suspension?.description && (
        <div className="suspended-account-detail">
          <span className="suspended-account-label">{__elakayText('t003', 'Details')}</span>
          <span>{suspension.description}</span>
        </div>
      )}
      <div className="suspended-account-detail">
        <span className="suspended-account-label">{__elakayText('t004', 'Suspended since')}</span>
        <span>{formatDate(suspension?.startAt)}</span>
      </div>
      <div className="suspended-account-detail">
        <span className="suspended-account-label">{__elakayText('t005', 'Until')}</span>
        <span>{formatDate(suspension?.endAt)}</span>
      </div>
      {supervisorName && (
        <div className="suspended-account-detail">
          <span className="suspended-account-label">{__elakayText('t007', 'Supervisor')}</span>
          <span>{supervisorName}</span>
        </div>
      )}

      {suspension?.origin === 'automatic' && suspension?.automaticRuleSnapshot && (
        <>
          <div className="suspended-account-detail">
            <span className="suspended-account-label">{__elakayText('t010', 'Maximum authorized points')}</span>
            <span>{suspension.automaticRuleSnapshot.maximumTotalPoints}</span>
          </div>
          <div className="suspended-account-detail">
            <span className="suspended-account-label">{__elakayText('t011', 'Points reached')}</span>
            <span>{suspension.automaticRuleSnapshot.totalPoints}</span>
          </div>
        </>
      )}

      <p className="suspended-account-help">
        {__elakayText('t008', 'If you believe this is a mistake or want to provide an explanation, please contact Elakay support.')}
      </p>

      <button type="button" className="suspended-account-back" onClick={onBack}>
        {__elakayText('t009', 'Back')}
      </button>
    </div>
  );
};

export default SuspendedAccountNotice;
